export default "__VITE_ASSET__B7Q54rCp__"